import styled from 'styled-components';

export const Container = styled.div`
  ${tw`block sm:block md:block lg:hidden xl:hidden`};
`;